import { apiFetch, Code, FetchReturn } from "../../lib/utils";

export interface TEmailTemplates {
    Id: number;
}

const ReviewEndpoint = "/EmailTemplates";
// // const Get = async (): Promise<TEmailTemplates
// []> => {
// //     const response = await apiFetch(ReviewEndpoint);
//     const reviews = await response.json();
//     return reviews;
// }

const escapeHtml = (unsafe: string) => {
    return unsafe
        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;")
        .replace(/"/g, "&quot;")
        .replace(/'/g, "&#039;");
};

// const Post = async (review: TEmailTemplates
// ): Promise<FetchReturn<TEmailTemplates
// >> => {
// //     try {
// //         const result = await apiFetch(ReviewEndpoint, "POST", { ...review });
//         //return created object instead of local object
//         return { Code: Code.OK, Message: "Success", Content: review }
//     } catch (error) {
//         return { Code: Code.ADD_ERR, Message: "Något gick fel, kunde inte skapa granskning", Content: review };
//     }
// }

// Post email template values to the EmailTemplate table
const PostEmailTemplate = async (templateName: string, header: string, body: string, active: boolean): Promise<any> => {
    try {
        const escapedBody = escapeHtml(body); // Escape the body content

        const response = await apiFetch(`${ReviewEndpoint}/api/emailtemplates/`, "POST", JSON.stringify({
            TemplateName: templateName,
            Header: header,
            Body: escapedBody,
            Active: active // Include the active status
        }));

        const contentType = response.headers.get("content-type");
        let result;

        if (contentType && contentType.includes("application/json")) {
            result = await response.json();  // Parse as JSON
        } else {
            result = { Message: await response.text() };  // Parse as plain text
        }

        return result;
    } catch (error) {
        // Check for 409 Conflict status
        if (error instanceof Response && error.status === 409) {
            return { code: "CONFLICT", message: "En mall med detta namn finns redan." }; // Return conflict code and message
        }

        console.error("Failed to create email template:", error);
        return { code: "ERROR", message: (error as Error).message }; // Return error code and message for UI to handle
    }
};

const UpdateEmailTemplate = async (
    id: string,
    templateName: string,
    header: string,
    body: string,
    active: boolean
): Promise<any> => {
    try {
        const escapedBody = escapeHtml(body); // Escape the body content

        const response = await apiFetch(`${ReviewEndpoint}/api/emailtemplates/${id}`, "PUT", JSON.stringify({
            TemplateName: templateName,
            Header: header,
            Body: escapedBody,
            Active: active // Send the active status
        }));

        const result = await response.json();
        return result;
    } catch (error) {
        console.error("Failed to update email template:", error);
        return null;
    }
};



// Add the GetById function to fetch an email template by its ID
const GetEmailTemplateById = async (id: string): Promise<any> => {
    try {
        const response = await apiFetch(`${ReviewEndpoint}/api/getemailtemplatebyid/${id}`);
        const template = await response.json();

        return template;
    } catch (error) {
        console.error("Failed to fetch email template:", error);
        return null;
    }
};

// Fetch all email templates
const GetAllEmailTemplates = async (): Promise<any[]> => {
    try {
        const response = await apiFetch(`${ReviewEndpoint}/api/getallemailtemplates/`);
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }
        return await response.json();
    } catch (error) {
        console.error("Failed to fetch email templates:", error);
        return [];
    }
};

// Delete an email template
// Delete an email template
const DeleteEmailTemplate = async (id: number): Promise<Response> => {
    try {
        const response = await apiFetch(`${ReviewEndpoint}/api/deleteemailtemplate/${id}`, "DELETE");
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }
        return response; // Return the response object
    } catch (error) {
        console.error(`Failed to delete email template with ID ${id}:`, error);
        throw error; // Propagate the error to the calling function
    }
};


export {
    // Get,
    // Post,
    PostEmailTemplate,
    GetEmailTemplateById,
    GetAllEmailTemplates,
    DeleteEmailTemplate,
    UpdateEmailTemplate
}